var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5333 1.62988L22.2623 7.42688L16.5703 5.84088",
    stroke: "#5578F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.263 7.42719C21.0238 5.03997 18.9529 3.18951 16.4419 2.22566C13.9308 1.26181 11.1536 1.25138 8.63541 2.19634C6.11718 3.14131 4.03244 4.97617 2.77536 7.35401C1.51827 9.73186 1.17596 12.4879 1.81314 15.101C2.45032 17.7141 4.02284 20.0032 6.23338 21.5355C8.44392 23.0678 11.1393 23.7371 13.8098 23.4169C16.4804 23.0966 18.941 21.809 20.7266 19.7974C22.5121 17.7859 23.4988 15.1899 23.5 12.5002",
    stroke: "#5578F6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a6d0647d3f6db4c968ed97e413099096.svg";
export { ForwardRef as ReactComponent };